var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { xs12: "" } },
    [
      _c(
        "v-tabs-items",
        {
          model: {
            value: _vm.selectedVisualization,
            callback: function($$v) {
              _vm.selectedVisualization = $$v
            },
            expression: "selectedVisualization"
          }
        },
        [
          _c(
            "v-tab-item",
            { key: "activate-map", attrs: { value: "activate-map" } },
            [
              _c("map-chart", {
                ref: "mapRef",
                attrs: {
                  "chart-data": _vm.dto,
                  width: _vm.visWidth,
                  height: _vm.visHeight
                },
                on: {
                  "click:item": function($event) {
                    return _vm.clickItem($event)
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            { key: "activate-barchart", attrs: { value: "activate-barchart" } },
            [
              _c("bar-chart", {
                attrs: {
                  "chart-data": _vm.dataForBarChart,
                  width: _vm.visWidth,
                  height: _vm.visHeight,
                  selectedSorting: _vm.selectedSorting
                },
                on: {
                  "input:selectedSorting": function($event) {
                    return _vm.selectSorting($event)
                  },
                  "click:item": function($event) {
                    return _vm.clickItem($event)
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-tab-item", {
            key: "activate-linechart",
            attrs: { value: "activate-linechart", disabled: true }
          }),
          _vm._v(" "),
          _c(
            "v-tab-item",
            { key: "activate-table", attrs: { value: "activate-table" } },
            [
              _c("table-chart", {
                attrs: {
                  "chart-data": _vm.dto,
                  width: _vm.visWidth,
                  height: _vm.visHeight
                },
                on: {
                  "click:item": function($event) {
                    return _vm.clickItem($event)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("fact-sheet", {
        attrs: { height: _vm.visHeight, "vis-width": _vm.visWidth },
        model: {
          value: _vm.factSheet,
          callback: function($$v) {
            _vm.factSheet = $$v
          },
          expression: "factSheet"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57799805", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57799805","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Charts.vue
// module id = null
// module chunks = 